// app/src/features/signals/TsdChartSlot.jsx
import React from "react";
import TsdChart from "../../components/timeline/TsdChart.jsx";

/**
 * The time-series chart at the foot of the timeline column (the frame's `tsdChart` slot): the
 * plotted signals' paths and axes over the timeline's framing. Nothing without an active forecast.
 * `TsdChart` keeps its own `ctx` literal (components/*), built here from the frame's.
 */
export default function TsdChartSlot({ ctx }) {
  const {
    active,
    tsdH,
    tsdAnimating,
    dragRef,
    onMD,
    screenToDay,
    tsdPaths,
    branches,
    series,
    tsdAxes,
    tsdHover,
    setTsdHover,
    hoveredBranch,
    setHoveredBranch,
    todayX,
    showTodayLine,
    resScreenX,
    fadeStartX,
    fadeEndX,
    showGenLine,
    genX,
    forecastingPhase,
    railPanelOpen,
    vw,
    theme,
  } = ctx;
  return (
    <>
      {active && (
        <TsdChart
          ctx={{
            tsdH,
            tsdAnimating,
            dragRef,
            onMD,
            screenToDay,
            tsdPaths,
            branches,
            series,
            tsdAxes,
            tsdHover,
            setTsdHover,
            hoveredBranch,
            setHoveredBranch,
            todayX,
            showTodayLine,
            resScreenX,
            fadeStartX,
            fadeEndX,
            showGenLine,
            genX,
            forecastingPhase,
            active,
            // The rail's panel is on the LEFT: the right axis stays at the edge, and the left
            // axis moves out from under the panel.
            chatOpen: false,
            leftInset: railPanelOpen ? "var(--rail-panel-w)" : 0,
            vw,
            theme,
          }}
        />
      )}
    </>
  );
}
